export class ARFeeErrorItem {
  transactionItemCode: string;
  transactionItemNumber: number;
  errorListRequired: string[] = [];
  errorListOptional: string[] = [];
}

export class ARFeeErrors {
  ARFeeErrorItems: ARFeeErrorItem[] = [];
}
